import { useQuery } from "@tanstack/react-query";

import { getWorksite } from "@/adapters/api";

// useWorksite loads the full worksite (incl. address coordinates, which the
// lightweight Canteiro view drops). Used by the edit page to hydrate the form.
export function useWorksite(id: string | undefined) {
	return useQuery({
		queryKey: ["worksite", id],
		queryFn: () => {
			if (!id) throw new Error("missing worksite id");
			return getWorksite(id);
		},
		enabled: !!id,
	});
}
